fx.ns("models", class ProductType extends fx.Model {

	constructor(data)
	{
		super(data);
	}

    // Declared in bottom, trick for old browsers
    //static BOOK = 1;
    //static PRINT = 2;
    //static FRAME = 3;
    //static CALENDAR = 4;
    //static POSTER = 5;

});

fx.ns("models.ProductType").BOOK = 1;
fx.ns("models.ProductType").PRINT = 2;
fx.ns("models.ProductType").FRAME = 3;
fx.ns("models.ProductType").CALENDAR = 4;
fx.ns("models.ProductType").POSTER = 5;	